import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {DynamicDialogRef} from "primeng/dynamicdialog";
import {interval, Subscription} from "rxjs";
import {COUNTER_START_VALUE} from "../../utils/tokens";

@Component({
  selector: 'auth-session-alert',
  templateUrl: './session-alert.component.html',
  styleUrls: ['./session-alert.component.css']
})
export class SessionAlertComponent implements OnInit, OnDestroy {

  counter: number;

  private subscription: Subscription;

  constructor(
    private ref: DynamicDialogRef,
    @Inject(COUNTER_START_VALUE) private COUNTER_START_VALUE: number
  ) {
    this.counter = this.COUNTER_START_VALUE;
  }

  ngOnInit(): void {
    this.subscription = interval(1000).subscribe(() => this.updateCounter());
  }

  closeDialog(value: boolean): void {
    this.ref.close(value);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private updateCounter(): void {
    this.counter--;
    if (this.counter === 0) {
      this.closeDialog(false);
    }
  }

}
